const FORM_URL = 'https://readdy.ai/api/form/d9mb6o0bdkpk99j7g8v0';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            <i className="ri-mail-send-line mr-1"></i>联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            联系与投稿
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            欢迎与我们取得联系，无论是资源反馈、合作洽谈还是内容投稿
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/60">
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-6">联系方式</h3>
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">电子邮箱</div>
                  <div className="text-sm text-foreground-500 mt-1">contact@91yingshi.example.com</div>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 shrink-0">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">微信公众号</div>
                  <div className="text-sm text-foreground-500 mt-1">91影视看片下载</div>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 shrink-0">
                  <i className="ri-question-answer-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">常见咨询</div>
                  <div className="text-sm text-foreground-500 mt-1">资源反馈 · 安装帮助 · 合作洽谈 · 内容投稿</div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/60">
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-6">给我们留言</h3>
            <form
              data-readdy-form=""
              id="contact-form"
              action={FORM_URL}
              method="POST"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement);
                if (honeypot && honeypot.value.trim()) {
                  alert('留言已提交，我们会尽快回复！');
                  form.reset();
                  return;
                }
                try {
                  const formData = new FormData(form);
                  formData.delete('phone_alt');
                  const body = new URLSearchParams(formData as unknown as Record<string, string>).toString();
                  const resp = await fetch(FORM_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body,
                  });
                  const text = await resp.text();
                  let serverMsg = '';
                  try { const p = JSON.parse(text); serverMsg = p?.meta?.message || p?.message || ''; } catch { serverMsg = text; }
                  if (resp.ok && (!serverMsg || !serverMsg.includes('spam'))) {
                    alert('留言已提交，我们会尽快回复！');
                    form.reset();
                  } else {
                    alert(serverMsg || '提交失败，请稍后重试');
                  }
                } catch {
                  alert('网络错误，请稍后重试');
                }
              }}
              className="space-y-4"
            >
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="您的称呼"
                  className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200 rounded-xl focus:outline-none focus:border-primary-400 transition-colors"
                />
              </div>
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="电子邮箱"
                  className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200 rounded-xl focus:outline-none focus:border-primary-400 transition-colors"
                />
              </div>
              <div>
                <textarea
                  name="message"
                  rows={3}
                  maxLength={500}
                  placeholder="请输入留言内容（500字以内）"
                  className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200 rounded-xl focus:outline-none focus:border-primary-400 transition-colors resize-none"
                ></textarea>
              </div>
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="honeypot-field" />
              <button
                type="submit"
                className="w-full px-6 py-3.5 bg-primary-500 text-white text-sm font-semibold rounded-xl hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-send-plane-line mr-2"></i>发送留言
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}